import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { createComment } from '../services/budgetCommentsService'
import { budgetCommentsKeys } from './budgetCommentsQueryKeys'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { filtersSelector } from '../../../redux/context/filters/selectors'
import type { BudgetComment } from '../types'

export const useCreateComment = () => {
  const queryClient = useQueryClient()
  const companyId = useSelector(contextCompanyIdSelector)
  const { budgetingScenario } = useSelector(filtersSelector)

  return useMutation({
    mutationFn: async ({
      comment,
      dimensions
    }: {
      comment: Omit<BudgetComment, 'id' | 'companyId' | 'userId' | 'createdAt' | 'updatedAt' | 'dimensionId'>
      dimensions?: string
    }) => {
      if (!companyId) {
        throw new Error('Company ID is required')
      }

      return createComment({
        companyId,
        comment,
        dimensions,
        budgetingScenarioId: budgetingScenario?.id
      })
    },

    onSuccess: () => {
      // Invalidate comments queries to refetch data
      queryClient.invalidateQueries({
        queryKey: budgetCommentsKeys.comments()
      })
    },

    onError: error => {
      console.error('Error creating comment:', error)
    }
  })
}
